/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */
var nolog = !customerloged?"Log in to your account to save your wishlist and access it anytime.<br>Alternatively, you can add products while you browse, but they won’t be saved for future visits.":"";
var loginbtn = !customerloged?"<br><a class='login' href='/account/login'>Log In to Your Account</a>":"";

var productCardMarkup =  `<div class="swy-details">
<div class="textsw">`+nolog+loginbtn+`</div>
</div>`+`<div class="custome-swy">
   {{#products}} 
   <div class="zpro-card">
<div id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
    <svg class="icon icon-close" aria-hidden="true" focusable="false">
                    <use href="#icon-close">
                    </use></svg>
     </div>
    <div class="zcard-image">
    
       <a  href="{{du}}"aria-label="{{dt}}" class="zcard-image-link" href="{{ card_product.url }}">
        <img alt="" src="{{iu}}">
</a>   </div>

    <div class="zcard-details">
        <a class="zcard-link" href="{{ card_product.url }}">
            <div class="zcard-title"> {{dt}}</div>
      
        </a>

      
  

</div></div>
   
   {{/products}}
</div>`;

var productCardEmpty = `<div class="swy-details">
<div class="textsw"><br>`+nolog+`<a href="/" class="s-btn">Continue Shopping</a>`+loginbtn+`</div>
</div>`;

function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}

function onAddToCartClick(e) {
	e.preventDefault();
	var productId = e.currentTarget.getAttribute("data-product-id");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
	var du = e.target.getAttribute("data-product-url");
	e.target.innerHTML = "Adding..";
	window._swat.replayAddToCart({
		empi: productId,
		du: du
	}, variantId, function(c) {
		e.target.innerHTML = "Added to Cart";
		e.target.setAttribute("data-state-cart", "swym-added");
		console.log("Successfully added product to cart.", c);
	}, function(e) {
		console.log(e);
	});
}

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch(function(products) {
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi){
				window._swat.removeFromWishList(product, function() {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
				});
			}
		});
	})
}

function swymRenderWishlist(swat) {
	// Get wishlist items
	swat.fetch(function(products) {
		console.log(products)
		var wishlistContentsContainer = document.getElementById("wishlist-items-container");
		var formattedWishlistedProducts = products.map(function(p) {
			p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
			p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
			p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
			return p;
		});
		var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
			products: formattedWishlistedProducts
		});
		if(wishlistContentsContainer){
			if(formattedWishlistedProducts.length > 0)
			{
				wishlistContentsContainer.innerHTML = productCardsMarkup;
				attachClickListeners();
			}else{
				wishlistContentsContainer.innerHTML = productCardEmpty;

			}

		}
	});
}

function attachClickListeners() {
	var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
	//   Add to cart Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
	console.log("Events attached!");
}

if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */
